// Sides are fixed to the vehicle, looking towards the front (decreasing X).
// Recompute from geometry so saved results using the old labels remain readable.
export function vehicleLateralBalance(lateral: any, centerOfGravity: any, loadSpace: any) {
  const rawY = centerOfGravity?.y
  const rawWidth = loadSpace?.width
  if (rawY == null || rawWidth == null) return null
  const y = Number(rawY)
  const width = Number(rawWidth)
  const origin = Number(loadSpace?.y ?? 0)
  if (!Number.isFinite(y) || !Number.isFinite(width) || width <= 0 || !Number.isFinite(origin)) return null
  const leftPercentage = Math.max(0, Math.min(100, 100 * (y - origin) / width))
  const rightPercentage = 100 - leftPercentage
  const imbalance = Math.abs(leftPercentage - rightPercentage)
  const maxImbalance = Number.isFinite(lateral?.maxImbalance) ? lateral.maxImbalance : 10
  return { ...lateral, leftPercentage, rightPercentage, imbalance, maxImbalance, isBalanced: imbalance <= maxImbalance }
}
